import { useEffect } from "react";
import { AttachMoney, PersonAdd } from "@mui/icons-material";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import MDBox from "@vendor/components/MDBox";
import MenuCard from "@vendor/examples/Cards/MenuCards";
import { MainLayout } from "@shared/ui/MainLayout";
import { ErrorServer } from "@shared/ui/alerts";
import { dollarUS } from "@shared/utils/moneyFormat";

import { ReferredCommissionSummary } from "../components/ReferredCommissionSummary";
import { useCommissionPayments } from "../hooks/useCommissionPayments";
import { countDistinctReferred, sumCommissionAmounts } from "../lib/totals";

export const ReferredCommissionPage = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const { data = [], isFetching, isError } = useCommissionPayments();

  useEffect(() => {
    if (isError) ErrorServer().then();
  }, [isError]);

  // Totales derivados de la data; no hace falta estado propio.
  const totalAmount = sumCommissionAmounts(data);
  const totalReferred = countDistinctReferred(data);

  return (
    <MainLayout loading={isFetching}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6, lg: 4, xl: 4 }}>
          <MDBox mb={1.5}>
            <MenuCard icon={PersonAdd} title={t("hiredReference") + ": " + totalReferred} />
          </MDBox>
        </Grid>
        <Grid size={{ xs: 12, md: 6, lg: 4, xl: 4 }}>
          <MDBox mb={1.5}>
            <MenuCard
              icon={AttachMoney}
              title={t("totalChargedForReferrals") + ": " + dollarUS.format(totalAmount)}
            />
          </MDBox>
        </Grid>
      </Grid>
      <MDBox py={3}>
        <ReferredCommissionSummary data={data} t={t} language={language} />
      </MDBox>
    </MainLayout>
  );
};
